import {Field, Formik} from "formik";
import {Button, Col, Form, Spinner} from "react-bootstrap";
import React, {useEffect, useRef} from "react";
import TextViewWithIcon from "../../../../ui/forms/TextViewWithIcon";
import ErrorArea from "../../../../ui/forms/ErrorArea";
import MainButton from "../../../../ui/forms/Buttons";
import {signUpSchema} from "./SignUpSchema";
import {Input} from "../../../../ui/forms/formik";

const SubmitFormStep = (props) => {
    const backText = 'Back';
    const signUpText = "Sign Up";

    const {onSubmit, isSubmitting, errors, onBackClick} = props;
    const {profession, clubAgency} = props;

    const {USER_SIGN_UP_GENERAL_ERROR: generalError} = errors;

    return (
        <Formik
            initialValues={{role: profession?.value}}
            validationSchema={signUpSchema}
            onSubmit={(values, {setErrors}) => onSubmit(values, setErrors)}
            validateOnMount
            validateOnChange
            validateOnBlur>
            {({
                  handleSubmit,
                  isValid,
                  dirty,
              }) => (
                <Form className="formik submit-form-step" onSubmit={handleSubmit}>
                    <Form.Row className="form--row">
                        <Col lg={6} xs={12} className="form--col">
                            <TextViewWithIcon svg={profession?.svg} text={profession?.label}/>
                        </Col>

                        <Col lg={6} xs={12} className="form--col">
                            <TextViewWithIcon svg={clubAgency?.svg} text={clubAgency?.label}/>
                        </Col>
                    </Form.Row>

                    <Form.Row className="form--row">
                        <Col xs={12} className="form--col first-name">
                            <Field
                                name="firstName"
                                placeholder="First Name"
                                component={SubmitFormStep.Input}
                                className="input input-flat input-xl"
                            />
                        </Col>

                        <Col xs={12} className="form--col last-name">
                            <Field
                                name="lastName"
                                placeholder="Last Name"
                                component={SubmitFormStep.Input}
                                className="input input-flat input-xl"
                            />
                        </Col>

                        <Col xs={12} className="form--col email">
                            <Field
                                name="email"
                                type="email"
                                placeholder="Email"
                                component={SubmitFormStep.Input}
                                className="input input-flat input-xl"

                            />
                        </Col>

                        <Col xs={12} className="form--col password">
                            <Field
                                name="password"
                                type="password"
                                placeholder="Password"
                                component={SubmitFormStep.Input}
                                className="input input-flat input-xl"

                            />
                        </Col>
                    </Form.Row>

                    {
                        generalError &&
                        <Form.Row className="form--row mb-5">
                            <Col xs={12} className="form--col">
                                <ErrorArea message={generalError}/>
                            </Col>
                        </Form.Row>
                    }

                    <Form.Row className="form--row">
                        <Col lg={6} xs={12} className="form--col">
                            <MainButton color="secondary" size="xl" text={backText} className="w-100" onClick={onBackClick}/>
                        </Col>

                        <Col lg={6} xs={12} className="form--col">
                            <Button type="submit" variant="primary" size="xl" disabled={isSubmitting || !isValid} block>
                                <div className="d-flex justify-content-center align-content-center align-items-center">
                                    {isSubmitting && <Spinner className="spinner" animation="border" variant="primary"/>}
                                    <span className="mr-2"> {signUpText} </span>
                                </div>
                            </Button>
                        </Col>
                    </Form.Row>
                </Form>
            )}
        </Formik>
    );
};

SubmitFormStep.Input = props => <Input errorMessagePosition="left-bottom" withoutMargin {...props}/>;
export default SubmitFormStep;
